module.exports = __webpack_public_path__ + "img/forcepointer.cf15f5c5.svg";